import { reducers } from './reducers';
import { persistentReducedStream } from '@ardoq/rxbeach';

const metamodels$ = persistentReducedStream('metamodels$', [], reducers);

export { metamodels$ };
